module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting-container"
  }, [_c('div', {
    staticClass: "setting-operate"
  }, [_c('button', {
    staticClass: "operate-spe3",
    class: {
      'operate-spe1': _vm.isA, 'es1': _vm.isEs, 'po1': _vm.isPo
    },
    on: {
      "click": _vm.changeStype1
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('staticSettings')))])]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isM),
      expression: "isM"
    }],
    staticClass: "operate-spe3",
    class: {
      'operate-spe1': _vm.isB, 'po1': _vm.isFr
    },
    on: {
      "click": _vm.changeStype2
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('dataSource')))])])]), _vm._v(" "), _c('el-card', {
    staticClass: "setting-main"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-587fc862"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chartSetting.vue
// module id = 1467
// module chunks = 7